module.exports = __webpack_public_path__ + "img/light_5.ee9f9631.png";